import { getGlobalLightHub, isIgnoreScript } from "./utils";
import { logger } from "./logger";

const fetchOptions = {
    credentials: 'include' as 'include',
    redirect: 'follow' as 'follow',
    mode: 'cors' as 'cors',
    method: 'GET'
};

export async function fetchUrlAndPrefetchAssets(url: string) {
    return getGlobalLightHub().origins._fetch.call(window, url, fetchOptions).then((res: Response) => {
        return res.text();
    }).then((text: string) => {
        const MATCH_RES_REGEX = /\"(https:)?\/\/.*?.\.(js|css)\"/g;

        getGlobalLightHub().origins._setTimeout.call(window, () => {
            try {
                const matchList = text.match(MATCH_RES_REGEX);
                matchList && matchList.forEach(item => {
                    try {
                        const url = JSON.parse(item);
                        if (url && !isIgnoreScript(url)) {
                            
                            getGlobalLightHub().origins._fetch.call(window, url);
                        }
                    } catch(e){}
                });
            } catch(e) {}
        }, 10);
        return text;
    });
}
